import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { FileText, Zap, MapPin, BookOpen, ShieldCheck, Lock, CreditCard } from 'lucide-react';
const trackInitiateCheckout = (value: number, contentName: string) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'InitiateCheckout', {
      value,
      currency: 'ARS',
      content_name: contentName
    });
  }
};
export function Hero() {
  return <section className="relative pt-10 pb-0 lg:pt-16 lg:pb-0 overflow-hidden bg-white/60 backdrop-blur-sm text-navy-900" data-id="element-100">
      <div className="container mx-auto px-4 relative z-10" data-id="element-101">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12" data-id="element-102">
          {/* LEFT — Text content */}
          <div className="flex-1 text-left" data-id="element-103">
            <motion.div initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="inline-block px-4 py-1.5 mb-5 text-xs font-semibold tracking-widest text-brand-blue bg-blue-50 rounded-full border border-blue-200 uppercase" data-id="element-104">
              Tu Solución Digital™
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-4xl md:text-5xl lg:text-6xl font-black leading-[0.95] mb-2 tracking-tight uppercase text-navy-900" data-id="element-105">
              Todo tu mes en Argentina.
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.15
          }} className="text-xl md:text-2xl font-bold text-brand-blue mb-5 tracking-wide uppercase" data-id="element-106">
              Listo. Desde hoy.
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="text-sm md:text-base font-normal text-slate-500 mb-5 max-w-lg" data-id="element-107">
              El sistema simple para ordenar tu plata en Argentina — sin
              finanzas, sin culpa — semana a semana
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="mb-6" data-id="element-108">
              <div className="space-y-1.5 text-sm text-black font-medium" data-id="element-109">
                <p data-id="element-110">📝 Actividades listas para usar</p>
                <p data-id="element-111">📊 Planillas para completar al toque</p>
                <p data-id="element-112">📋 Protocolos paso a paso</p>
                <p data-id="element-113">🚫 Sin adivinar · Sin obsesión · Sin empezar de cero</p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.35
          }} className="flex flex-wrap gap-2 mb-6 text-xs font-bold" data-id="element-114">
              <div className="flex items-center gap-1.5 bg-blue-600 px-3 py-1.5 rounded-full border-2 border-navy-900 text-white" data-id="element-115">
                <FileText size={14} data-id="element-116" /> 100% PDF
              </div>
              <div className="flex items-center gap-1.5 bg-blue-600 px-3 py-1.5 rounded-full border-2 border-navy-900 text-white" data-id="element-117">
                <Zap size={14} className="text-yellow-300" data-id="element-118" /> Acceso en 1 MIN
              </div>
              <div className="flex items-center gap-1.5 bg-blue-600 px-3 py-1.5 rounded-full border-2 border-navy-900 text-white" data-id="element-119">
                <MapPin size={14} data-id="element-120" /> 🇦🇷 Argentina
              </div>
              <div className="flex items-center gap-1.5 bg-blue-600 px-3 py-1.5 rounded-full border-2 border-navy-900 text-white" data-id="element-121">
                <BookOpen size={14} data-id="element-122" /> 3 Tomos
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} data-id="element-123">
              <a href="https://www.tusoluciondigital.shop/cart/43638879551554:1" onClick={() => trackInitiateCheckout(19999, 'Sistema 12 Semanas')} className="inline-flex items-center justify-center w-full md:w-auto text-lg md:text-xl px-10 py-5 mb-4 bg-green-500 text-black font-black tracking-wider uppercase rounded-full border-2 border-black shadow-2xl shadow-green-500/40 animate-pulse hover:animate-none hover:bg-green-600 hover:shadow-green-500/50 hover:-translate-y-1 active:translate-y-0 transition-all duration-300" data-id="element-124">
                ✅ QUIERO MI SISTEMA 12 SEMANAS
              </a>

              <div className="flex flex-wrap gap-3 text-xs" data-id="element-125">
                <div className="flex items-center gap-1.5 bg-green-50 text-green-700 px-3 py-1.5 rounded-full border border-green-200 font-semibold" data-id="element-126">
                  <ShieldCheck size={14} data-id="element-127" /> Garantía 7 días
                </div>
                <div className="flex items-center gap-1.5 bg-green-50 text-green-700 px-3 py-1.5 rounded-full border border-green-200 font-semibold" data-id="element-128">
                  <Lock size={14} data-id="element-129" /> Pago seguro
                </div>
                <div className="flex items-center gap-1.5 bg-green-50 text-green-700 px-3 py-1.5 rounded-full border border-green-200 font-semibold" data-id="element-130">
                  <CreditCard size={14} data-id="element-131" /> Mercado Pago
                </div>
              </div>
            </motion.div>
          </div>

          {/* RIGHT — Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.5,
          type: 'spring'
        }} className="flex-1 relative max-w-sm lg:max-w-md" data-id="element-132">
            <img src="https://cdn.magicpatterns.com/uploads/1GeASH5GkiZPHBixPErD22/mockup_transparente_pro.png" alt="Llegué a fin de mes en Argentina - 3 Tomos" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-133" />
          </motion.div>
        </div>

        {/* Bottom spacer */}
        <div className="h-16 lg:h-24" data-id="element-134"></div>
      </div>
    </section>;
}